import { useTranslation } from 'react-i18next';

export default function Scarcity() {
  const { t } = useTranslation();

  const painPoints = [
    {
      icon: 'ri-time-line',
      title: t('scarcity.pain1.title'),
      desc: t('scarcity.pain1.desc'),
    },
    {
      icon: 'ri-lock-line',
      title: t('scarcity.pain2.title'),
      desc: t('scarcity.pain2.desc'),
    },
    {
      icon: 'ri-alert-line',
      title: t('scarcity.pain3.title'),
      desc: t('scarcity.pain3.desc'),
    },
    {
      icon: 'ri-price-tag-3-line',
      title: t('scarcity.pain4.title'),
      desc: t('scarcity.pain4.desc'),
    },
  ];

  return (
    <section className="py-32 bg-gradient-to-b from-[#0a0a0a] to-[#1a1a1a]">
      <div className="max-w-[1200px] mx-auto px-8">
        <div className="text-center space-y-6 mb-20">
          <div className="inline-block px-5 py-2 bg-red-500/10 border border-red-500/30 rounded-full">
            <span className="text-sm font-medium text-red-400 uppercase tracking-wider">
              {t('scarcity.label')}
            </span>
          </div>
          <h2 className="text-5xl lg:text-6xl font-light leading-tight max-w-[900px] mx-auto">
            {t('scarcity.title')}
          </h2>
          <p className="text-lg text-[#b8b8b8] max-w-[700px] mx-auto">
            {t('scarcity.subtitle')}
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-16">
          {painPoints.map((point, index) => (
            <div
              key={index}
              className="bg-[#0f0f0f] border-2 border-red-500/20 rounded-2xl p-8 hover:border-red-500/40 transition-all duration-300"
            >
              <div className="w-14 h-14 flex items-center justify-center bg-red-500/10 rounded-xl mb-6">
                <i className={`${point.icon} text-2xl text-red-400`}></i>
              </div>
              <h3 className="text-2xl font-light mb-4">{point.title}</h3>
              <p className="text-[#999999] leading-relaxed">{point.desc}</p>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-r from-[#d4af37]/10 to-[#d4af37]/5 border-2 border-[#d4af37]/30 rounded-2xl p-10 text-center">
          <div className="w-16 h-16 flex items-center justify-center bg-[#d4af37]/20 rounded-full mx-auto mb-6">
            <i className="ri-vip-crown-line text-3xl text-[#d4af37]"></i>
          </div>
          <p className="text-xl text-white leading-relaxed max-w-[800px] mx-auto">
            {t('scarcity.solution')}
          </p>
        </div>
      </div>
    </section>
  );
}
